import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { Container } from '@fiverr-private/layout_components';
import AiSuggestionRow from '../AiSuggestionRow';
import ChipsContainer from '../ChipsContainer';
import TrendingChip from '../TrendingChip';

const AiPillEmptyState = ({ historyIds, popularIds }) => {
    if (!historyIds.length && !popularIds.length) {
        return null;
    }

    return (
        <Container display="flex" flexDirection="column" gap="4" paddingBottom="2">
            {!!historyIds.length && (
                <Container display="flex" flexDirection="column" gap="1">
                    <Text
                        paddingLeft={{ default: '0', md: '4' }}
                        color="grey_900"
                        fontSize={{ default: 'b_xs', md: 'b_sm' }}
                    >
                        <I18n k="search_bar.ai_pill.recent" />
                    </Text>
                    <Container as="ul" display="flex" flexDirection="column" gap="1">
                        {historyIds.map((id, index) => (
                            <AiSuggestionRow key={id} id={id} index={index} isHistory />
                        ))}
                    </Container>
                </Container>
            )}
            {!!popularIds.length && (
                <Container display="flex" flexDirection="column" gap="1" paddingLeft={{ default: '0', md: '4' }}>
                    <Text color="grey_900" fontSize={{ default: 'b_xs', md: 'b_sm' }}>
                        <I18n k="search_bar.ai_pill.trending" />
                    </Text>
                    <ChipsContainer ids={popularIds} Chip={TrendingChip} />
                </Container>
            )}
        </Container>
    );
};

AiPillEmptyState.propTypes = {
    historyIds: PropTypes.arrayOf(PropTypes.string),
    popularIds: PropTypes.arrayOf(PropTypes.string),
};

AiPillEmptyState.defaultProps = {
    historyIds: [],
    popularIds: [],
};

export { AiPillEmptyState };
export default AiPillEmptyState;
